<div *ngIf="isLoaded" aria-label="Section-AccountTotals-ProjectAccounting" (click)="$event.stopPropagation()" fxLayout="row" class="container">
    <account-detail-card fxFlex="auto" [index]="id" [link]="link" [totals]="totals" type="PA">
    </account-detail-card>
</div>